"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FFAnalyticsUtils = void 0;
const integrations_1 = require("./integrations");
const data_1 = require("./data");
const Cookies = __importStar(require("es-cookie"));
const ts_md5_1 = require("ts-md5");
class FFAnalyticsUtils {
    static isProd() {
        return (location.host === "www.themenlohouse.com");
    }
    static extractUtmSource() {
        const utmSource = Cookies.get("utm_source");
        if (utmSource === undefined) {
            return undefined;
        }
        return utmSource;
    }
    static isConsentAllow() {
        const dlData = data_1.FFAnalyticsData.extractDlData();
        const cookieConsent = Cookies.get("ccpaconsent_status");
        const consentVal = (((dlData.dataConsent !== null) &&
            (dlData.dataConsent !== "")) ?
            dlData.dataConsent :
            (((cookieConsent !== undefined) &&
                (cookieConsent !== null) &&
                (cookieConsent !== "")) ?
                cookieConsent :
                null));
        const doesConsent = (consentVal === "allow" || consentVal === null);
        return doesConsent;
    }
    static loopAllServices(cbCheck, cbAction, enforceUtm = true) {
        const utmSource = this.extractUtmSource();
        const doesConsent = this.isConsentAllow();
        integrations_1.AnAllIntegs.forEach((integ) => {
            if (!integ.isLoaded()) {
                return true;
            }
            if (cbCheck !== null && !cbCheck(integ)) {
                return true;
            }
            if (enforceUtm &&
                (integ.utmSource !== null) &&
                (integ.utmSource !== utmSource)) {
                return true;
            }
            if (!doesConsent && !integ.shouldSendIfNoConsent) {
                return true;
            }
            try {
                cbAction(integ);
            }
            catch (e) {
                console.error("ANALYTICS", e);
            }
            return true;
        });
        return true;
    }
    static hashValue(rawVal) {
        return ts_md5_1.Md5.hashAsciiStr(rawVal);
    }
}
exports.FFAnalyticsUtils = FFAnalyticsUtils;
